import { T } from 'ramda';
import { UserUtils, FeatureUtils, PermissionsUtils, ROUTES } from '@cyberint/common-utils';
import { hasFeatureAccess } from './auth-utils';

export const checkAccessToTab = ({
  tab,
  permissions,
  navMenuFeatures,
  user,
  selectedTenant,
  actualTenant,
  customers,
  flags
}) => {
  /** If navMenuFeatures is provided with TEM only FF, it will be evaluated against menu items associated with this domain.
   * For example navMenuFeatures includes only FEATURES.TEM_FEATURES will show only Menus with TEM_DOMAINS
   * If navMenuFeatures includes only FEATURES.CAASM_FEATURES will show only Menus with CAASM_DOMAINS
   * if both [...FEATURES.TEM_FEATURES, ...FEATURES.CAASM_FEATURES] provided, menu will be filtered for TEM and CAASM Only.
   * Otherwise, all menus (ERM, TEM, CAASM) will be visible.
   * */
  const domains = tab?.domains ?? ROUTES.ERM_DOMAINS;
  const features_access = tab?.features_access;
  const allFeaturesAccess = tab?.allFeaturesAccess;
  const isVisible = tab?.isVisible;
  const useParentFeatures = tab?.useParentFeatures;
  const useParentOrChildrenFeatures = tab?.useParentOrChildrenFeatures;
  const predicate = tab?.predicate;

  if (
    navMenuFeatures?.length &&
    PermissionsUtils.isFilterNavMenu({ selectedCustomer: selectedTenant, user }) &&
    !FeatureUtils.isAllowedDomains({ domains, features: navMenuFeatures })
  ) {
    return false;
  }

  const tenantFeatures = actualTenant?.features || selectedTenant?.features;
  const allowedDomains = actualTenant?.domains || selectedTenant?.domains; // preparation for pre-calculated domains

  if (!FeatureUtils.isAllowedDomains({ domains, features: tenantFeatures, allowedDomains })) {
    return false;
  }

  if (typeof isVisible === 'function') {
    return isVisible({ user, selectedTenant, actualTenant, flags, permissions });
  }
  if (UserUtils.isCyberintRootUser(user)) {
    return true;
  }
  if (!user) {
    return false;
  }

  if (!features_access && !predicate) {
    return true;
  }

  if (useParentOrChildrenFeatures) {
    return (
      hasFeatureAccess(tenantFeatures, features_access, allFeaturesAccess) ||
      hasFeatureAccess(user.customer?.features, features_access, allFeaturesAccess) ||
      customers?.some(c => hasFeatureAccess(c.features, features_access, allFeaturesAccess))
    );
  }

  /** If the page is agnostic to selected tenant (KB, CVE, DataLake..),
   *  it will be visible based on logged-in user tenant regardless of the selected tenant */
  const features = (!useParentFeatures && tenantFeatures) || user.customer?.features || [];
  const decisionFunction = predicate || T;
  const hasManyCustomers = customers?.length > 0;

  return (
    hasFeatureAccess(features, features_access, allFeaturesAccess) &&
    decisionFunction({ user, features, flags, selectedTenant, actualTenant, hasManyCustomers, customers, permissions })
  );
};
